import React from 'react';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import { BlogDetailPage } from './pages/BlogDetailPage';
import { BlogListPage } from './pages/BlogListPage';
import { ContactPage } from './pages/ContactPage';
import { HomePage } from './pages/HomePage';
import { NewsDetailPage } from './pages/NewsDetailPage';
import { NewsListPage } from './pages/NewsListPage';
import './App.scss';

function App() {
  return (
    <BrowserRouter>
      <div className="site-shell">
        <header className="site-header">
          <Link className="brand" to="/">
            <div className="logo-mv">
              <img className="logo-mv-bg" src="/assets/waouh-logo-bg.svg" alt="WAOUH" />
              <div className="logo-anime">
                <img src="/assets/waouh-logo-center.svg" alt="" aria-hidden="true" />
              </div>
            </div>
            <img className="header-logo" src="/assets/waouh-header-logo.svg" alt="" aria-hidden="true" />
          </Link>
          <nav className="site-nav">
            <Link to="/">Home</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/news">News</Link>
            <Link to="/contact">Contact</Link>
          </nav>
        </header>

        <main className="site-main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/category/:categoryId" element={<BlogListPage />} />
            <Route path="/blog/:id" element={<BlogDetailPage />} />
            <Route path="/news" element={<NewsListPage />} />
            <Route path="/news/:id" element={<NewsDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>

        <footer className="site-footer">
          @WAOUH All rights reserved.
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
